export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-paw-21ce7566b663ff8d4d3d1c41ee6ebfb9.svg";